// app/frontend/router/routes.js
export default [
  {
    path: '/',
    name: 'Landing',
    component: () => import('../pages/Landing.vue')
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('../pages/Signup.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../pages/ForgotPassword.vue')
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../pages/ResetPassword.vue')
  },
  {
    path: '/app',
    component: () => import('../pages/Learn.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: 'vocabulaire'
      },
      {
        path: 'vocabulaire',
        name: 'LearnVocabulaire',
        component: () => import('../pages/Vocabulaire.vue')
      },
      {
        path: 'grammaire',
        name: 'LearnGrammaire',
        component: () => import('../pages/Grammaire.vue')
      },
      {
        path: 'chatbot',
        name: 'LearnChatbot',
        component: () => import('../pages/Chatbot.vue')
      }
    ]
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('../pages/Account.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/grammar/:lang?',
    name: 'Grammar',
    component: () => import('../pages/Grammar.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../pages/Support.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'AdminDashboard',
    component: () => import('../pages/admin/AdminDashboard.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/cgu',
    name: 'Terms',
    component: () => import('../pages/Terms.vue')
  },
  {
    path: '/cgv',
    name: 'Sales',
    component: () => import('../pages/Sales.vue')
  },
  {
    path: '/mentions-legales',
    name: 'LegalNotice',
    component: () => import('../pages/LegalNotice.vue')
  },
  {
    path: '/confidentialite',
    name: 'Privacy',
    component: () => import('../pages/Privacy.vue')
  }
]
